<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('roles')">Uprawnienia</inertia-link>
      <span class="text-shtax-400 font-medium">/</span> {{ form.name }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="update" class="z-0">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nazwa" />

          <multiselect-input v-model="form.guard_name" :error="form.errors.guard_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Przestrzeń" :options="guard_options" :multiple="false" :close_on_select="true" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Usuń uprawnienie</button>
          <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Aktualizuj</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    permission: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.permission.name,
        guard_name: this.permission.guard_name
      }),
      guard_options: ['web', 'api']
    }
  },
  methods: {
    update() {
      this.form.post(this.route('permissions.update', this.permission.id), {
        onSuccess: () => this.form.reset(),
      })
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewny że chcesz usunąć wybrane uprawnienie użytkownika?',
        text: 'Przywrócenie usuniętego uprawnienia nie będzie już możliwe',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('permissions.destroy', this.permission.id))
        }
      })
    }
  }
}
</script>
